/*
 * You will now see a Globally scoped method named <CTPauseResume(Boolean pause)> 
 * That once called will pause Clicktale transmission together with disabling ongoing Mutation Observer listeners.
 * */

export const pauseCTMonitor = (passedBool) => {
	try {
		if(passedBool){
			if (typeof window.CTPauseResume != 'undefined') window.CTPauseResume(passedBool);
		}else{
			setTimeout(function(){if (typeof window.CTPauseResume != 'undefined') window.CTPauseResume(passedBool);}, 250);
		}
	} catch (e) {
		//don't care
	}
};
